import { combineReducers } from 'redux';

import allIds from './allIds';
import byId from './byId';
import detailedByUtilityId from './detailedByUtilityId';
import isFetchingDetailedOffers from './isFetchingDetailedOffers';

export const reducer = combineReducers({
  allIds,
  byId,
  detailedByUtilityId,
  isFetchingDetailedOffers
});
